import { NextTable } from '@core/table';

import { useBranchesTable } from '../hooks';
import { BranchesTableContext } from '../contexts';

export const BranchesTable = () => {
  const { columns } = useBranchesTable();

  return <NextTable context={BranchesTableContext} sortable={true} filterable={true} columns={columns} />;
};
